const header = document.querySelector('header');
const body = document.body;

// 🚫 Disable sticky header on business card page.
if (body.classList.contains('path-averton-business-card')) {
  if (header) {
    header.classList.remove('header--sticky', 'header--hidden');
  }
} else if (!header) {
  console.warn('Header element not found');
} else {
  const SCROLL_THRESHOLD = 10;
  const STICKY_POINT = 30;

  let lastScrollY = window.scrollY;
  let ticking = false;

  const updateHeader = (currentScrollY) => {
    const isAtTop = currentScrollY <= STICKY_POINT;
    const scrollingDown = currentScrollY > lastScrollY;
    const scrollDelta = Math.abs(currentScrollY - lastScrollY);

    // At top: remove all classes
    if (isAtTop) {
      header.classList.remove('header--sticky', 'header--hidden');
    }
    // Below sticky point: manage sticky state
    else {
      header.classList.add('header--sticky');

      // Only change visibility if scroll delta exceeds threshold
      if (scrollDelta >= SCROLL_THRESHOLD) {
        if (scrollingDown) {
          header.classList.add('header--hidden');
        } else {
          header.classList.remove('header--hidden');
        }
      }
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateHeader(window.scrollY);
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
}